import { useEffect } from 'react';

interface SeoOptions {
  /** Full document title, e.g. "فيلا في الرياض | صفقات 24". */
  title?: string;
  /** Meta description for this page (also mirrored to og:description). */
  description?: string;
}

const SITE_TITLE = 'صفقات 24 | Safaqat 24';

function setMeta(selector: string, content: string) {
  const el = document.head.querySelector<HTMLMetaElement>(selector);
  if (el) el.setAttribute('content', content);
}

/**
 * Per-route document title + meta description for the SPA (client-side; the
 * static defaults in index.html remain the fallback for link scrapers that
 * don't execute JS). Restores the site-wide defaults on unmount so titles
 * never leak between routes.
 */
export function useSeo({ title, description }: SeoOptions) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', title);
    }
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
    }
    setMeta('meta[property="og:url"]', window.location.href);
    return () => {
      document.title = prevTitle || SITE_TITLE;
    };
  }, [title, description]);
}
